<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>

<div [formGroup]="boxInterfaceForm" fxLayout="column">
  <div class="mat-error" *ngIf="generalError">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Name </mat-label>
    <input formControlName="name" matInput type="text" name="name">
    <mat-error
      *ngIf="boxInterfaceForm.controls.name?.errors?.name && !boxInterfaceForm.controls.name?.errors?.required">
      Please enter a valid name
    </mat-error>
    <mat-error *ngIf="boxInterfaceForm.controls.name?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Description </mat-label>
    <input formControlName="description" matInput type="text" name="description">
    <mat-error *ngIf="!boxInterfaceForm.controls.description?.errors?.required">
      Please enter a valid description
    </mat-error>
    <mat-error *ngIf="boxInterfaceForm.controls.description?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="boxInterface = _boxInterface; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveBoxInterface()" [disabled]="boxInterfaceForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>